<template>
  <div>
    <div class="van-action-sheet__item van-hairline--top">
      <a href="tel:400-0865-285">客服热线：400 086 5285</a>
    </div>
    <div class="van-action-sheet__item van-hairline--top">
      <button class="action-btn" @click="onSelect(serviceWechat.sale)">微信客服：{{serviceWechat.sale}}（点击复制）</button>
    </div>
    <div class="van-action-sheet__cancel" @click="change">
      取消
    </div>
  </div>
</template>

<script>
import ClipboardJS from 'clipboard'
import { getWechatNumber } from '@/utils'

export default {
  data () {
    return {
      serviceWechat: {}
    }
  },
  created () {
    getWechatNumber().then(res => {
      this.serviceWechat = res;
    });
  },
  methods: {
    change () {
      this.$emit('close')
    },
    // 微信复制
    onSelect (item) {
      let that = this
      var clipboard = new ClipboardJS('.action-btn', {
        text: function (trigger) {
          return item
        }
      })
      clipboard.on('success', function (e) {
        that.$toast('微信号已经复制到粘贴板！')
        e.clearSelection()
      })

      clipboard.on('error', function (e) {
        that.$toast('该设备不支持自动复制')
      })

      this.change();
    },
  }
}
</script>

<style lang="less" scoped>
.van-action-sheet__item, .van-action-sheet__cancel {
  text-align: center;
}
</style>



